import { LineItemTypes } from './constants';

/** Site name is not meaningful on hourly/misc line items on dispatch UIs; hide it to avoid confusion. */
export function shouldHideSiteNameOnDispatchUi(lineItemType: string | undefined): boolean {
    return lineItemType === LineItemTypes.Hourly || lineItemType === LineItemTypes.Misc;
}
